<span>{{incidentStatuses[data[fieldName]]}}</span>
